// HeroSection.js
import React from 'react';

const HeroSection = () => {
  return (
    <div className="bg-gradient-to-r from-[#113262] to-[#113262] pt-28 pb-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-4 tracking-tight">
          Investor Center
        </h1>
        <p className="text-xl text-white text-center max-w-3xl mx-auto opacity-90">
          Your comprehensive resource for investment information, guides, and insights
        </p>
      </div>
    </div>
  );
};

export default HeroSection;